import W3cHtml from '../../assets/img/W3C_html.png'
import W3cCss from '../../assets/img/W3C_css.png'

export default function Footer() {
    return (
        <div className="container-fluid footer_section">
            <div className="row">
                <div className="col-md-3 mt-5 mb-0 mb-md-4 d-flex justify-content-center justify-content-md-end">
                    <a href="">
                        <img src={W3cHtml} alt="optimizado html" className="w3c_img me-2" />
                    </a>
                    <a href="">
                        <img src={W3cCss} alt="optimizado css" className="w3c_img" />
                    </a>
                </div>
                <div className="col-md-6 footer_data text-center my-3 my-md-5">
                    <p className="mb-0"><span>Tribunal Electoral del Poder Judicial de la Federación (TEPJF) </span></p>
                    <p className="mb-0">Teléfonos 55-5728-2300 y 55-5484-5410.</p>
                    <p className="mb-0">Todos los derechos reservados.</p>
                    <p className="my-2">
                        <a href="" target="_blank"><span>Protección de Datos Personales</span>
                        </a>
                    </p>

                    <p className="mb-0">Para su correcta visualización, se recomienda utilizar</p>
                    <p className="mb-0">
                        <a href="https://www.google.com.mx/chrome/browser/desktop/" target="_blank">Google Chrome</a>
                        {" "}
                        o
                        {" "}
                        <a href="https://www.mozilla.org/es-MX/firefox/new/" target="_blank">Firefox</a>
                    </p>
                </div>
                <div className="col-3">

                </div>
            </div>
        </div>
    );
}